export const SecretLabels: Record<
    "project" | "user" | "organization" | "serviceAccount",
    {
        newSecretModalDescription: string;
        newSecretModalCreatedToast: string;
        emptyStateDescription: string;
    }
> = {
    project: {
        newSecretModalDescription:
            "Add a new secret to this project, secrets added here will override any existing organization secrets",
        newSecretModalCreatedToast:
            "The secret will be available in new environments and propagated to running environments. A rebuild may be needed to apply changes.",
        emptyStateDescription: "This project has no secrets.",
    },
    user: {
        newSecretModalDescription:
            "Secrets added here will be available in all your environments and will override any existing organization or project secrets",
        newSecretModalCreatedToast:
            "The secret will be available in new environments and propagated to running environments. A rebuild may be needed to apply changes.",
        emptyStateDescription: "You don't have any secrets.",
    },
    organization: {
        newSecretModalDescription: "Secrets added here will be available in all environments in the organization",
        newSecretModalCreatedToast:
            "The secret will be available in new environments and propagated to running environments. A rebuild may be needed to apply changes.",
        emptyStateDescription: "This organization has no secrets.",
    },
    serviceAccount: {
        newSecretModalDescription:
            "Add a secret that will be available in environments created by this service account",
        newSecretModalCreatedToast:
            "The secret will be available in new environments and propagated to running environments. A rebuild may be needed to apply changes.",
        emptyStateDescription: "This service account has no secrets.",
    },
};
